module.exports = __webpack_public_path__ + "img/icon-chrome.a549efe7.svg";